export function MailIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 5H20C21.1 5 22 5.9 22 7V17C22 18.1 21.1 19 20 19H4C2.9 19 2 18.1 2 17V7C2 5.9 2.9 5 4 5ZM4 7V7.01L12 12L20 7.01V7H4ZM20 17V9.24L12.53 13.9C12.21 14.1 11.79 14.1 11.47 13.9L4 9.24V17H20Z"
        fill="currentColor"
      />
    </svg>
  );
}
